import { render, staticRenderFns } from "./buyerCancellationNotice.vue?vue&type=template&id=32999926&scoped=true&"
import script from "./buyerCancellationNotice.vue?vue&type=script&lang=js&"
export * from "./buyerCancellationNotice.vue?vue&type=script&lang=js&"
import style0 from "./buyerCancellationNotice.vue?vue&type=style&index=0&id=32999926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32999926",
  null
  
)

export default component.exports